(function () {
    'use strict';

    var controllerId = 'SignInController';

    angular.module('app.core').controller(controllerId, SignInController);

    SignInController.$inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$translate',
        'userSvc',
        '$state',
        'ngDialog',
        '$window',
        "restoreUrlService",
        "$timeout",
        "otpService",
        "notifierSvc",
        "mcpService"
    ];

    function SignInController(
        $rootScope,
        $scope,
        $stateParams,
        $translate,
        userSvc,
        $state,
        ngDialog,
        $window,
        restoreUrlService,
        $timeout,
        otpService,
        notifierSvc,
        mcpService
    ) {
        // Captcha state (managed by phone-input directive)
        $scope.captchaVerified = false;
        $scope.ETToken = null;
        $scope.isTurkishPhone = true; // Updated by directive via two-way binding
        $scope.eimageCaptchaKey = null;
        $scope.eimageCaptchaValue = null;

        // Emlakjet OAuth callback handling
        handleEmlakjetCallback();

        function handleEmlakjetCallback() {
            var emlakjetParams = mcpService.checkEmlakjetCallback();

            if (emlakjetParams) {
                // If params incomplete, show error immediately
                if (emlakjetParams.hasError) {
                    notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                    return;
                }

                $scope.emlakjetLoading = true;

                mcpService.handleEmlakjetCallback(emlakjetParams).then(
                    function (result) {
                        if (result && result.token) {
                            userSvc.signInEmlakjet(result.token).then(
                                function () {
                                    $scope.emlakjetLoading = false;
                                    $window.location.reload();
                                },
                                function () {
                                    $scope.emlakjetLoading = false;
                                }
                            );
                        } else {
                            $scope.emlakjetLoading = false;
                            notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                        }
                    },
                    function (err) {
                        $scope.emlakjetLoading = false;
                        notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                    }
                );
            }
        }

        //** navigation manipulation */

        if ($(".toggle-map-wrapper").length > 0) {
            var filterVal = "blur(5px)";
            $(".toggle-map-wrapper")
                .css("filter", filterVal)
                .css("webkitFilter", filterVal)
                .css("mozFilter", filterVal)
                .css("oFilter", filterVal)
                .css("msFilter", filterVal);
            $(".navbar")
                .css("filter", filterVal)
                .css("webkitFilter", filterVal)
                .css("mozFilter", filterVal)
                .css("oFilter", filterVal)
                .css("msFilter", filterVal);
            $(".ed-wrap")
                .css("filter", filterVal)
                .css("webkitFilter", filterVal)
                .css("mozFilter", filterVal)
                .css("oFilter", filterVal)
                .css("msFilter", filterVal);
        }


        $scope.message = {
            info: $stateParams.info,
            infoType: $stateParams.type
        };

        if ($stateParams.status === 'reset') {
            $scope.message.info = $translate.instant('reset_info');
        } else if ($stateParams.status === 'activated') {
            $scope.message.info = $translate.instant('activate_info');
        } else if ($stateParams.status === 'valuation') {
            $scope.message.info = $translate.instant('l_warning2');
        } else if ($stateParams.status === 'multiuser') {
            $scope.message.info = $translate.instant('multiuser_info');
        } else if ($stateParams.status === 'guard') {
            $scope.message.info = (window.lang === "tr" ? "Bu sayfayı görüntülemek için yetkili bir hesap ile giriş yapmalısınız." : "You should sign in with an authorized account to view this page.");
        } else if ($stateParams.status === 'renta') {
            $scope.message.info = (window.lang === "tr" ? "KiraTrink için lütfen giriş yapınız.<br>Ücretsiz Kaydol seçeneği ile hemen ücretsiz hesap<br>oluşturabilirsiniz." : "You should sign in for KiraTrink.<br>You can create your account free of charge<br>by following Create Account link.");
        }

        $scope.$on('$translateLoadingEnd', function () {
            if ($stateParams.status === 'reset') {
                $scope.message.info = $translate.instant('reset_info');
            } else if ($stateParams.status === 'activated') {
                $scope.message.info = $translate.instant('activate_info');
            } else if ($stateParams.status === 'multiuser') {
                $scope.message.info = $translate.instant('multiuser_info');
            }
        });

        $scope.loginLoading = false;
        $scope.syncLoading = false;

        $scope.user = {
            email: '',
            password: '',
            phoneNumber: ''
        };


        if ($rootScope.isBank && $rootScope.clientData.phoneNumber)
            $scope.user = Object.assign($scope.user, $rootScope.clientData);




        //password visibilityu
        $scope.showPassword = false;
        $scope.passwordVisibility = function () {
            $scope.showPassword = !$scope.showPassword;
        };

        //email or phone login
        var isMail = localStorage.getItem('isMailLogin') && !$rootScope.isTop;
        if (isMail === "true") {
            $scope.isMail = true;
        } else {
            $scope.isMail = false;
        }
        $scope.toggleMailLogin = function () {
            $scope.isMail = !$scope.isMail;
            window.localStorage.setItem('isMailLogin', JSON.stringify($scope.isMail));
            if (!$scope.isMail) {
                $scope.user.email = null;
            }
            if (!$scope.isMail) {
                $timeout(function () {
                    var phoneInput = document.getElementById('phone-nput');
                    if (phoneInput) {
                        phoneInput.focus();
                    }
                }, 100);
            }
        };


        //<- CAMPAIGN BLOCK STARTS
        $scope.isCampaign = $stateParams.status === 'campaign' && $stateParams.code;
        $scope.checks = {
            first: false,
            second: false,
            third: false
        };

        if ($scope.isCampaign) {
            $scope.user.password = $stateParams.code;
            $scope.user.email = $stateParams.email;
        }
        $scope.termsModal = function () {
            ngDialog.open({
                templateUrl: 'app/content/sozlesme/' + window.lang + '/kullanim.html',
                controller: ['$scope', ($scope) => {
                    $scope.onModal = true;
                }]
            });
        };
        $scope.gizlilikModal = function () {
            ngDialog.open({
                templateUrl: 'app/content/sozlesme/' + window.lang + '/gizlilik.html',
                controller: ['$scope', ($scope) => {
                    $scope.onModal = true;
                }]
            });
        };

        //CAMPAIGN BLOCK ENDS ->

        if ($rootScope.SignedIn)
            restoreUrlService.returnTo();


        // sign in block starts

        $scope.signInEmail = signInEmail;
        function signInEmail() {
            $scope.loginLoading = true;
            $scope.user.language = $window.langCode();
            userSvc.signIn($scope.user, $scope.isCampaign)
                .then(
                    function (result) {
                        ngDialog.close();
                        if (result.data === "202") {
                            $state.go("activateEmail", { langcode: $rootScope.lang, email: result.email });
                        } else {
                            $scope.loginLoading = false;
                        }
                    },
                    function () {
                        $scope.loginLoading = false;
                    });
        }

        $scope.signInPhone = signInPhone;
        $scope.confirmEjMerge = confirmEjMerge;
        var pendingAdditionalConfirmationResult = null;
        var ejMergeConfirmationDialog = null;

        function signInPhone() {
            // Require captcha for non-Turkish phone numbers
            if (!$scope.isTurkishPhone && (!$scope.captchaVerified || !$scope.ETToken)) {
                notifierSvc.show({ message: $translate.instant('turnstile_required'), type: "warning" });
                return;
            }

            $scope.loginLoading = true;
            $scope.user.IsEjMergeConfirmed = undefined;
            // Pass turnstile token for non-Turkish phone numbers
            var ETToken = !$scope.isTurkishPhone ? $scope.ETToken : null;
            var eimageCaptchaData = !$scope.isTurkishPhone && $scope.eimageCaptchaKey ? { key: $scope.eimageCaptchaKey, value: $scope.eimageCaptchaValue } : null;

            otpService.callOtp("loginAndRegister", 1, $scope.user.phoneNumber, null, null, ETToken, eimageCaptchaData).then(function (result) {
                decideSyncing(result);
            }, function (err) {
                $scope.loginLoading = false;
                $scope.captchaVerified = false;
                $scope.ETToken = null;
                if ($('.ngdialog').length === 0)
                    $translate(otpService.purifyOtpError(err)).then(function (message) {
                        notifierSvc.show({ message: message, type: "warning" });
                    });
                if (err.validateRequest) {
                    retryOTP(err.validateRequest);
                }
            });
        }

        function decideSyncing(result) {
            //OTP closed, canceled by user
            if (!result) {
                $scope.loginLoading = false;
                return;
            }

            if (result.requiresAdditionalConfirmation && typeof $scope.user.IsEjMergeConfirmed === "undefined") {
                openAdditionalConfirmationDialog(result);
                return;
            }

            //continue syncing decision. continue with e-mail or skip synching
            $scope.user.validateRequest = result.validateRequest;
            if (result.registered) {
                $scope.loginLoading = false;
                if (result.registeredUsers && result.registeredUsers.registeredAddresses && result.registeredUsers.registeredAddresses.length > 1) {
                    $scope.mailAddresses = result.registeredUsers.registeredAddresses;
                    openSyncingDialog();
                } else {
                    registerAndLogin();
                }
            } else {
                $scope.loginLoading = false;
                if ($rootScope.isBank)
                    registerAndLogin();
                else
                    openSyncingDialog();
            }
        }

        function openSyncingDialog() {
            ngDialog.open({
                templateUrl: 'app/security/mail-dialog.modal.html',
                scope: $scope,
            });
        }

        function openAdditionalConfirmationDialog(result) {
            $scope.loginLoading = false;
            pendingAdditionalConfirmationResult = result;
            ejMergeConfirmationDialog = ngDialog.open({
                templateUrl: 'app/security/ej-merge-confirmation.modal.html',
                scope: $scope,
                showClose: false,
                closeByEscape: false,
                closeByDocument: false,
                closeByNavigation: false
            });
        }

        function confirmEjMerge(isConfirmed) {
            $scope.user.IsEjMergeConfirmed = isConfirmed;
            if (ejMergeConfirmationDialog) {
                ejMergeConfirmationDialog.close();
                ejMergeConfirmationDialog = null;
            }
            var result = pendingAdditionalConfirmationResult;
            pendingAdditionalConfirmationResult = null;
            decideSyncing(result);
        }

        function registerAndLogin() {
            $scope.loginLoading = true;
            if ($scope.user.phoneNumber)
                $scope.user.phoneNumber = $scope.user.phoneNumber.replace(/\s+/g, '').replaceAll(' ', '');
            // TODO: should we give default permissions?
            $scope.user.permissions = [30, 40, 50, 60, 110, 120, 130, 140];
            userSvc.registerAndLogin($scope.user).then(
                function () {
                    ngDialog.close();
                    $scope.loginLoading = false;
                },
                function (err) {
                    $scope.loginLoading = false;
                    // if ($('.ngdialog').length === 0)
                    $translate(otpService.purifyOtpError(err)).then(function (message) {
                        notifierSvc.show({ message: message, type: "warning" });
                    });
                }
            );
        }

        function skipSyncing() {
            $scope.user.email = null;
            if (confirm($translate.instant('migrating_warning'))) {
                registerAndLogin();
            }
        }
        $scope.skipSyncing = skipSyncing;


        function retryOTP(validateRequest) {
            otpService.callOtp('retry', validateRequest.verificationType, validateRequest.verificationAddress, validateRequest.codeExpireDate, validateRequest.verificationToken).then(
                function (resp) {
                    if ($scope.isStep2) {
                        $scope.user.validateRequest = resp.validateRequest;
                        registerAndLogin();
                    } else {
                        decideSyncing(resp);
                    }
                },
                function (err) {
                    $scope.loginLoading = false;
                    otpService.closeDialog();
                    if (err.validateRequest) {
                        retryOTP(err.validateRequest);
                    }
                }
            );
        }

        $scope.syncLoading = false;
        $scope.validations = {
            emailInUse: false,
            emailValid: false
        };
        $scope.syncAccounts = function () {
            if ($scope.checkingEmail)
                return;
            $scope.syncLoading = true;
            if ($scope.user.email && !$scope.mailAddresses) {

                //if email is not in use, proceed to login
                if (!$scope.validations.emailInUse) {
                    registerAndLogin();
                    $scope.syncLoading = false;
                    return;
                }

                //if email is in use, proceed to syncing
                otpService.callOtp("loginAndRegister", 0, $scope.user.email).then(function (result) {
                    if (!result) {
                        $scope.syncLoading = false;
                        return;
                    }
                    $scope.user.validateRequest = result.validateRequest;

                    $scope.syncLoading = false;
                    registerAndLogin();
                }, function (err) {
                    otpService.closeDialog();
                    $scope.syncLoading = false;
                    if (err.validateRequest) {
                        retryOTP(err.validateRequest);
                    }
                });
            } else {
                registerAndLogin();
                $scope.syncLoading = false;
            }

        };

        // Close modal and handle navigation
        $scope.closeModal = function () {
            ngDialog.close();

            // Check if there's navigation history
            if ($window.history.length > 1) {
                $window.history.back();
            } else {
                // No history, navigate to landing page
                $state.go('default', { langcode: $rootScope.lang });
            }
        };

        // Cleanup event listeners on scope destroy
        // Note: Do NOT call ngDialog.close() here as it causes infinite recursion
        // The dialog is already being destroyed when $destroy fires
        // Turnstile cleanup is handled by phone-input directive
        //signin block ends

    }
})();
